import {
    LEAVE_PATTERN_FETCHING,
    LEAVE_PATTERN_FAILED,
    LEAVE_PATTERN_SUCCESS,
  } from "../actions/types";
  
  const initialState = {
    result: null,
    isFetching: false,
    isError: false,
  };
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case LEAVE_PATTERN_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case LEAVE_PATTERN_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case LEAVE_PATTERN_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
  }
  